import * as yup from 'yup';

export const MAX_407_LETTER_SIZE = 50; // MB

export const snapIdValidation = yup
  .string()
  .nullable()
  .when('isAffiliatedExchangeOrFINRA', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('You need to upload a 407 letter'),
  });
